import initialState from './AdvertisersInitialState';
import reducers from './AdvertisersReducer';

export default {
  initialState,
  reducers,
};
